import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { SocialSubNav } from "@/components/admin/SocialSubNav";
import { socialDiagnostics } from "@/lib/social-diagnostics.functions";

export const Route = createFileRoute("/admin/social/diagnostics")({
  component: DiagPage,
  head: () => ({
    meta: [
      { title: "Social diagnostics · Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});

function DiagPage() {
  const qc = useQueryClient();
  const run = useServerFn(socialDiagnostics);
  const q = useQuery({ queryKey: ["social-diagnostics"], queryFn: () => run() });
  const data: any = q.data ?? {};

  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <h1 className="mb-2 text-2xl font-bold">Social diagnostics</h1>
      <p className="mb-4 text-sm text-muted-foreground">
        Live health checks for the reverse-mortgage social pipeline: GHL, Lovable AI, cron, storage,
        and the compliance lexicon self-test.
      </p>
      <SocialSubNav />

      <div className="mb-4 flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={() => qc.invalidateQueries({ queryKey: ["social-diagnostics"] })}>Re-run</Button>
        {data.generatedAt && <span className="text-xs text-muted-foreground">Ran {new Date(data.generatedAt).toLocaleString()}</span>}
      </div>

      {q.isLoading ? <p className="text-sm text-muted-foreground">Loading…</p> :
        <div className="space-y-3">
          {(data.checks ?? []).map((c: any) => (
            <div key={c.name} className={`rounded-lg border p-3 ${c.ok ? "border-emerald-200 bg-emerald-50" : "border-rose-200 bg-rose-50"}`}>
              <div className="flex items-center justify-between">
                <div className="font-semibold">{c.name}</div>
                <span className={`rounded px-2 py-0.5 text-xs font-semibold ${c.ok ? "bg-emerald-200 text-emerald-900" : "bg-rose-200 text-rose-900"}`}>
                  {c.ok ? "OK" : "FAIL"}
                </span>
              </div>
              <div className="mt-1 text-xs">{c.detail}</div>
              {typeof c.latencyMs === "number" && <div className="text-[10px] text-muted-foreground">{c.latencyMs} ms</div>}
            </div>
          ))}
        </div>
      }
    </div>
  );
}
